module.exports = __webpack_public_path__ + "assets/textures/violin_tex_normal.d6c9d0e64b4f72adae16096ef240cc0b.jpg";